import type {
  OrganizationListItem,
  OrganizationStatus,
} from '@nucleus-commerce/api-client/platform';

export const RECENT_COUNT = 6;

export interface OrganizationSummary {
  total: number;
  byStatus: Record<OrganizationStatus, number>;
  /** Newest first, as the backend orders the list. */
  recent: OrganizationListItem[];
  /** True when the page cap stopped the count before the end of the list. */
  truncated: boolean;
}

/** Counts every status and keeps the newest few. Pure so the numbers can be unit-tested. */
export function summarizeOrganizations(
  items: readonly OrganizationListItem[],
  truncated: boolean,
): OrganizationSummary {
  const byStatus: Record<OrganizationStatus, number> = { active: 0, suspended: 0, closed: 0 };
  for (const organization of items) byStatus[organization.status] += 1;
  return { total: items.length, byStatus, recent: items.slice(0, RECENT_COUNT), truncated };
}
